exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--19-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!fullcalendar/dist/fullcalendar.min.css"), "");

// module
exports.push([module.id, "\n/*@import './../../../plugins/calenders/fullcalendar.css';*/\n", ""]);

// exports
